import React, { useState } from "react";

// import JS files
import Navbar from "../shares/others/Navbar";
import Banner from "./Banner";
import ImgList from "../shares/others/ImgList";
import SpecialNews from "./SpecialNews";
import TextList from "../shares/others/TextList";
import Persons from "./Persons";
import Media from "./Media";
import Supporter from "./Supporter";
import Chief from "./Chief";
import Footer from "../shares/others/Footer";

// import others files

const Homepage = (props) => {
  return (
    <>
      <Navbar active_item="homepage" />
      <div className="mx-8 2xl:mx-32" style={{ fontFamily: "yekan" }}>
        <div className="grid md:grid-cols-8 md:gap-8 mt-8">
          <div className=" md:col-span-5">
            <Banner />
            <div className="md:col-span-5 md:grid grid-cols-2 md:gap-4 md:h-[32rem] mt-4 md:mt-8">
              <SpecialNews />
            </div>
          </div>
          <div className=" md:col-span-3 mt-8 md:mt-0">
            <div className="relative">
              <ImgList />
            </div>
            <div className="mt-8">
              <TextList header="پربیننده‌ترین" />
            </div>
          </div>
        </div>
        <Persons />
        <Media />
        <Chief />
        <Supporter />
      </div>
      <Footer />
    </>
  );
};

export default Homepage;
